import styled from "styled-components";
import { satsToBtc } from "./utils";

const Section = styled.section`
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-bottom: 0.2rem;
  font-size: 1rem;
`;

const SectionNote = styled.p`
  font-size: 0.75rem;
  color: #a3abba;
  margin-bottom: 0.5rem;
  max-width: 70ch;
`;

// six blocks is an hour of history and will not fit on a phone
const Row = styled.div`
  display: flex;
  gap: 0.6rem;
  overflow-x: auto;
  padding-bottom: 0.4rem;
`;

const Block = styled.div`
  flex: 0 0 auto;
  width: 9.5rem;
  padding: 0.5rem 0.6rem;
  border: 1px solid #3f3f44;
  border-top: 3px solid ${({ $tip }) => ($tip ? "#62c4ff" : "#3f3f44")};
  border-radius: 3px;
  font-size: 0.75rem;
`;

const Height = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: #e8e9ed;
`;

const Age = styled.p`
  margin: 0 0 0.35rem;
  color: ${({ $tip }) => ($tip ? "#62c4ff" : "#a3abba")};
`;

const Detail = styled.p`
  margin: 0;
  color: #a3abba;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// the point of the whole section: the tape stops being a feed that scrolls away
// and becomes transactions that visibly land somewhere
const Confirmed = styled.p`
  margin: 0.35rem 0 0;
  padding-top: 0.35rem;
  border-top: 1px solid #3f3f44;
  color: #0eed0e;
`;

const Empty = styled.p`
  font-size: 0.8rem;
  color: #a3abba;
`;

const fmtAge = (timestamp) => {
  const seconds = Math.max(0, Math.floor(Date.now() / 1000 - timestamp));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${minutes % 60}m ago`;
};

const RecentBlocks = ({ blocks, confirmations }) => (
  <Section>
    <SectionTitle>Blocks as they land</SectionTitle>
    <SectionNote>
      Every ten minutes or so a block is mined and some of the transactions above
      stop being pending. Where a block confirmed transactions this page had
      already seen, it says how many.
    </SectionNote>
    {blocks.length === 0 ? (
      <Empty>Recent blocks are unavailable right now.</Empty>
    ) : (
      <Row>
        {blocks.map((block, index) => {
          const matched = confirmations[block.height];
          const fees = block.extras?.totalFees;
          return (
            <Block key={block.id} $tip={index === 0}>
              <Height>#{block.height.toLocaleString()}</Height>
              <Age $tip={index === 0}>{fmtAge(block.timestamp)}</Age>
              <Detail title={block.extras?.pool?.name}>
                {block.extras?.pool?.name ?? "Unknown pool"}
              </Detail>
              <Detail>{block.tx_count.toLocaleString()} txs</Detail>
              <Detail>{(block.size / 1000000).toFixed(2)} MB</Detail>
              {Number.isFinite(fees) && (
                <Detail>{satsToBtc(fees).toFixed(3)} BTC fees</Detail>
              )}
              {/* "seen here" rather than "confirmed": the block confirmed
                  thousands, this is only the slice this page had watched */}
              {matched !== undefined && (
                <Confirmed>
                  {matched === 0
                    ? "none seen here"
                    : `${matched.toLocaleString()} seen here`}
                </Confirmed>
              )}
            </Block>
          );
        })}
      </Row>
    )}
  </Section>
);

export default RecentBlocks;
